import { render, staticRenderFns } from "./DemoList.vue?vue&type=template&id=ae4edad0"
import script from "./DemoList.vue?vue&type=script&lang=js"
export * from "./DemoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports